import { ws } from "../../../utils/common";

export const getListQuestion = async ({ id_association }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "user-question/",
    { id_association },
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const getSingleQuestion = async ({ id_association, id_question }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "notification/" + id_question,
    { id_association, question: id_question, id_event: 0 },
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};
